import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { IoIosSettings } from "react-icons/io";
import { CgProfile } from "react-icons/cg";
import '../styles/TopNavBar.css';

const pageTitles = {
  "/home/stats": "Stats",
  "/home/calendar": "Calendar",
  "/home/workout": "Workout",
  "/home/scales": "Scales",
  "/home/settings": "Settings",
  "/home/profile": "Profile",
  "/home/stats_pages/workout-log": "Workout Log",
  "/home/stats_pages/muscle-distribution": "Muscle Stats"
};

const TopNavBar = () => {
  const location = useLocation();
  const title = pageTitles[location.pathname] || "Home";

  // Get the profile image URL from localStorage
  const profileImageUrl = localStorage.getItem('profilePicture') || null;
  return (
    <div className="top-nav-bar">
      <NavLink to="/home/settings" className={({ isActive }) => (isActive ? 'active' : '')}>
        <IoIosSettings />
        {/*<span>Settings</span>*/}
      </NavLink>

      {/* Centered Page Title */}
      <h2 className="page-title">{title}</h2>

      <NavLink to="/home/profile" className={({ isActive }) => (isActive ? 'active' : '')}>
        {/* Display the profile image if it exists */}
        {profileImageUrl ? (
          <img
          src={profileImageUrl}
          alt=""
          className="profile-image"
          style={{ width: '3rem', height: '3rem', borderRadius: '50%' }}
          referrerPolicy="no-referrer"
        />
        ) : (
          <CgProfile />
        )}

      </NavLink>
    </div>
  );
};

export default TopNavBar;
